<template>
        <modal
            name="mass-add-work-days"
            class="modal--translation mass-work-days-modal"
            v-cloak height="auto"
            width="620px"
            :scrollable="true"
            :adaptive="true"
            :pivot-y="0.15"
            @before-open="beforeOpen"
        >
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="fal fa-fw" :class="mode === 'plan' ? 'fa-calendar-alt' : 'fa-clock'"></i>{{ title }}
                </h5>
                <button @click="closeModal()" type="button" class="close close-modal">
                    <i class="fal fa-fw fa-times"></i>
                </button>
            </div>

            <div class="modal-body">
                <batch-impact-summary
                    v-if="days.length"
                    :days="days"
                    :selected-days="dates"
                    action="fill"
                    :mode="mode"
                    :trans="trans.bulk"
                />

                <work-day-embed-form
                    v-show="mode === 'reality'"
                    ref="workDayEmbedForm"
                    :work-interval-types="workIntervalTypes"
                    :default-interval="defaultIntervalReality"
                    :default-form-data="defaultFormDataReality"
                    :daily-working-fund="dailyWorkingFund"
                    :trans="trans"
                />

                <shift-plan-embed-form
                    v-show="mode === 'plan'"
                    ref="shiftPlanEmbedForm"
                    :work-interval-types="planIntervalTypes"
                    :default-interval="defaultIntervalPlan"
                    :default-form-data="defaultFormDataPlan"
                    :trans="trans"
                />

                <b-alert
                    v-if="intervalIsOverlaid && !isDiffMore"
                    show variant="danger"
                    class="col-12 d-flex align-items-center mt-3"
                >
                    <i class="fal fa-exclamation-circle fa-2x mr-2"></i>
                    <strong>
                        {{ trans.form.overlay_intervals }}
                    </strong>
                </b-alert>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-link" @click="closeModal()" :disabled="loading">
                    {{ trans.cancelBtn }}
                </button>
                <span class="mass-work-days-modal__spacer"></span>
                <button
                    @click="submitForm()"
                    type="submit"
                    class="btn btn-primary"
                    :disabled='loading'
                >
                    <i class="fal fa-fw mr-1" :class="loading ? 'fa-spin fa-spinner' : 'fa-check'"></i>{{ trans.saveBtn }}
                </button>
            </div>
        </modal>
</template>

<script>
import {cloneDeep} from 'lodash';
import BatchImpactSummary from '../show/BatchImpactSummary';

    export default {
        name: 'mass-work-days-modal-form',
        components: {BatchImpactSummary},
        data: function() {
            return {
                loading: false,
                mode: 'reality',
                dates: [],
                days: [],
                defaultIntervalReality: {
                    work_interval_type: 'work',
                    compensation_holiday: null,
                    from: moment().hours(8).minutes(0).seconds(0).format('HH:mm'),
                    to: moment().hours(12).minutes(0).seconds(0).format('HH:mm')
                },
                defaultIntervalPlan: {
                    plan_interval_type: 'work',
                    from: moment().hours(8).minutes(0).seconds(0).format('HH:mm'),
                    to: moment().hours(12).minutes(0).seconds(0).format('HH:mm')
                },
                intervalIsOverlaid: false,
                isDiffMore: false,
                defaultFormDataReality: {},
                defaultFormDataPlan: {}
            }
        },

        props: {
            'baseUrl': {
                type: String
            },
            'basePlanUrl': {
                type: String
            },
            'employeeContractId': {
                type: Number
            },
            'workIntervalTypes': {
                type: Array
            },
            'planIntervalTypes': {
                type: Array
            },
            'selectedMonth': {
                type: String
            },
            'trans': {
                type: Object
            },
            'dailyWorkingFund': {
                type: Number,
                required: false,
                default: () => {
                    return 7;
                }
            }
        },

        computed: {
            title() {
                return this.mode === 'plan'
                    ? this.trans.bulk.title_fill_plan
                    : this.trans.bulk.title_fill_reality;
            }
        },

        methods: {
            beforeOpen(event) {
                const params = event.params || {};

                this.defaultFormDataReality = { intervals: cloneDeep([this.defaultIntervalReality]) };
                this.defaultFormDataPlan = { intervals: cloneDeep([this.defaultIntervalPlan]) };

                this.mode = params.mode === 'plan' ? 'plan' : 'reality';
                this.dates = params.dates || [];
                this.days = params.days || [];
            },

            submitForm() {
                if (this.mode === 'plan') {
                    this.submitPlan();
                } else {
                    this.submitReality();
                }
            },

            submitReality() {
                const _this = this;
                const data = this.$refs.workDayEmbedForm.getData();

                data.dates = this.dates;

                this.loading = true;
                this.$emit('setmassbuttonloading', true);

                if (this.$refs.workDayEmbedForm.validateIntervals()) this.intervalIsOverlaid = true;
                else this.intervalIsOverlaid = false;

                if (this.$refs.workDayEmbedForm.validateWorkedHolidays()) this.isDiffMore = true;
                else this.isDiffMore = false;

                if (!this.intervalIsOverlaid && !this.isDiffMore) {
                    axios.post(this.baseUrl, data).then(function (response) {
                        return _this.onSuccess(response);
                    }).catch(function (errors) {
                        return _this.onFail(errors);
                    });
                } else {
                    this.loading = false;
                    this.$emit('setmassbuttonloading', false);
                }
            },

            submitPlan() {
                const _this = this;
                const data = this.$refs.shiftPlanEmbedForm.getData();

                data.employee_contract_id = this.employeeContractId;
                data.dates = this.dates;

                if (this.$refs.shiftPlanEmbedForm.validateIntervals()) {
                    this.intervalIsOverlaid = true;
                    return;
                } else {
                    this.intervalIsOverlaid = false;
                }

                this.loading = true;
                this.$emit('setmassbuttonloading', true);

                axios.post(this.basePlanUrl, data).then(function (response) {
                    return _this.onSuccess(response);
                }).catch(function (errors) {
                    return _this.onFail(errors);
                });
            },

            onSuccess(response) {
                this.closeModal();

                this.$emit('refreshattendance');
                this.$emit('refreshcalendar');
                this.$emit('refreshbalances');
                this.$emit('setmassbuttonloading', false);

                this.loading = false;

                if (response.data.type == 'warning') {
                  this.$notify({ type: 'warning', title: 'Upozornenie', text: response.data.message ? response.data.message : 'Some data not created.' });
                } else {
                  this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully created.' });
                }
            },

            onFail(error) {
                this.closeModal();

                this.$emit('refreshattendance');
                this.$emit('refreshcalendar');
                this.$emit('refreshbalances');
                this.$emit('setmassbuttonloading', false);

                this.loading = false;

                const errorMsg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'An error has occured.';

                this.$notify({ type: 'error', title: 'Error!', text: errorMsg });
            },

            closeModal() {
                this.$modal.hide('mass-add-work-days');
            }
        }

    }
</script>




// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/modals/MassWorkDaysModalForm.vue